// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".licenseAgreement-module__orderedList__18juN li{margin:0 0 1rem 0}\n", ""]);
// Exports
exports.locals = {
	"orderedList": "licenseAgreement-module__orderedList__18juN"
};
module.exports = exports;
